/* sâmago · Catálogo
   - Deja abiertos los grupos de filtros verticales (pills siempre visibles).
   - Convierte el filtro de precio de Dawn en un slider doble con botón "Aplicar",
     ligado a los inputs GTE/LTE nativos.
   - Re-inyecta el slider tras el re-render AJAX de Dawn (que NO dispara
     shopify:section:load) para que nunca reaparezcan los inputs crudos "De/Para".
   - Normaliza el rango de precio en todos los puntos (slider, URL, pill de filtros
     activos): el mínimo nunca supera al máximo y jamás se aplica un filtro invertido.
   IMPORTANTE: price-facet.liquid renderiza value/data-max con money_without_currency
   (formato AR "1.195.000,00"), NO enteros. Hay que parsear ese formato, no strip de dígitos. */
(function () {
  // Parsea un monto en cualquier formato (AR "1.195.000,00", US "1195000.00", "1195000") -> número real.
  function parseMoney(s) {
    s = (s == null ? '' : s).toString().trim().replace(/[^\d.,]/g, '');
    if (!s) return null;
    var lc = s.lastIndexOf(','), ld = s.lastIndexOf('.');
    var dec = lc > ld ? lc : ld;
    var fracLen = dec > -1 ? s.length - dec - 1 : 0;
    if (dec > -1 && fracLen > 0 && fracLen <= 2) {
      // el último separador es decimal
      var ip = s.slice(0, dec).replace(/[.,]/g, '') || '0';
      return parseFloat(ip + '.' + s.slice(dec + 1));
    }
    return parseInt(s.replace(/[.,]/g, ''), 10);
  }
  // Formatea un número al formato de moneda AR sin símbolo (== money_without_currency del shop).
  function moneyAR(n) {
    try { return Number(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return String(n); }
  }
  function fmt(n) { return '$' + moneyAR(n); }
  // $100.000 es el umbral que aplica en todo el país. En CABA, el beneficio
  // también se habilita desde $50.000 según el código postal del checkout.
  var FREE_SHIPPING_THRESHOLD = 100000;
  var MAX_ACTIVE_BRANDS = 12;
  // Native facet.range_max includes the full collection, not only the current page.
  function sliderStep(realMax) {
    return Math.max(1, Math.pow(10, Math.floor(Math.log10(Math.max(1, realMax))) - 2));
  }
  function extendedMax(realMax) {
    var step = sliderStep(realMax);
    return Math.max(step, Math.ceil((realMax || 0) / step) * step);
  }
  // Editorial priority, validated against the live catalog (docs/research/brand-priority-2026-09-09.md).
  // Order only available contextual candidates; this does not claim a sales ranking.
  var BRAND_PRIORITY = ["Apple", "Samsung", "Philips", "Bosch", "Colgate", "Dove", "Natura", "Tramontina", "Nivea", "Gillette", "L'Oréal Paris", "La Roche-Posay", "Pantene", "Sedal", "Oral-B", "Puma", "Xiaomi", "Gadnic", "Dermaglós", "Maria Cher", "Maybelline", "Avon", "CeraVe", "Rimmel London", "Logitech", "Atma", "L'Oréal Professionnel", "Issue", "Plusbelle", "Algabo", "Fidelité", "Rimmel", "Cher Mix", "Koxis", "Porto Brasil Cerâmica", "Mishka", "Lidherma", "Hikvision", "FV", "Kärcher", "Black+Decker", "Vichy", "Isdin", "Rexona", "Cif", "Sensodyne", "Always", "Pampers", "Head & Shoulders", "Wella", "Schwarzkopf Professional", "Montagne", "La Planchetta", "Saphirus", "Philco", "Porto Brasil", "Issue Professional", "L'Oréal", "Natura Tododia", "NATURA LUMINA", "Huggies", "Kotex", "OFF!", "GUM", "Revlon", "Kingston", "Havaianas", "Johnson's", "Listerine", "Old Spice"];
  var BRAND_PREVIEW_ROWS = 3;
  // Un rango de precio jamás queda invertido: min <= max siempre, venga del slider, de la URL
  // o de un fallback. Toda pill/filtro/listado pasa por acá antes de usarse.
  function normalizeRange(rawMin, rawMax) {
    return { min: Math.min(rawMin, rawMax), max: Math.max(rawMin, rawMax) };
  }

  function getSamagoRoot() {
    return document.querySelector('.samago-collection, .samago-search-results');
  }

  function getScopedSelector(selector) {
    var root = getSamagoRoot();
    return root ? root.querySelector(selector) : null;
  }

  function getScopedSelectorAll(selector) {
    var root = getSamagoRoot();
    return root ? root.querySelectorAll(selector) : [];
  }

  function getActiveFiltersBox() {
    return getScopedSelector('.samago-activefilters');
  }

  function closeMobileFacetsDrawer(button) {
    var disclosure = button && button.closest('.mobile-facets__disclosure');
    var opener = disclosure && disclosure.querySelector(':scope > summary');
    if (opener && disclosure.open) opener.click();
  }

  function syncMobilePriceRangeInputs(form) {
    form.querySelectorAll('price-range').forEach(function (priceRange) {
      var slider = priceRange.querySelector('.samago-price-slider');
      var inputs = priceRange.querySelectorAll('input.field__input');
      var rmin = slider && slider.querySelector('.rmin');
      var rmax = slider && slider.querySelector('.rmax');
      if (!rmin || !rmax || inputs.length < 2) return;
      var range = normalizeRange(+rmin.value, +rmax.value);
      var sliderMax = +rmax.max;
      var gte = inputs[0];
      var lte = inputs[1];
      gte.value = range.min > 0 ? String(range.min) : '';
      lte.value = range.max < sliderMax ? String(range.max) : '';
    });
  }

  function submitMobileFacets(button) {
    var form = button && button.closest('form#FacetFiltersFormMobile');
    if (!form) return;
    syncMobilePriceRangeInputs(form);
    // Los campos vacíos (ej. precio sin elegir) no viajan: evita ?filter.v.price.gte=
    // colgando de la URL y del historial.
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var searchParams = params.toString();
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(searchParams, { target: button });
      closeMobileFacetsDrawer(button);
      return;
    }
    window.location.assign(window.location.pathname + (searchParams ? '?' + searchParams : ''));
  }

  function bindMobileFacetInputGuard(root) {
    root.querySelectorAll('form#FacetFiltersFormMobile').forEach(function (form) {
      if (form.dataset.samagoMobileInputGuardBound) return;
      form.dataset.samagoMobileInputGuardBound = '1';
      form.addEventListener('input', function (event) {
        if (event.target.matches('[data-samago-native-brand-search]')) return;
        if (event.target.matches('input[name="filter.p.vendor"]') && event.target.checked) {
          var selected = form.querySelectorAll('input[name="filter.p.vendor"]:checked');
          if (selected.length > MAX_ACTIVE_BRANDS) event.target.checked = false;
        }
        event.stopImmediatePropagation();
      }, true);
    });
  }

  function bindNativeBrandSelectionLimit(root) {
    root.querySelectorAll('input[name="filter.p.vendor"]').forEach(function (input) {
      if (input.dataset.samagoBrandLimitBound) return;
      input.dataset.samagoBrandLimitBound = '1';
      input.addEventListener('input', function (event) {
        if (!input.checked) return;
        var form = input.closest('form');
        var checked = form ? form.querySelectorAll('input[name="filter.p.vendor"]:checked') : [];
        if (checked.length > MAX_ACTIVE_BRANDS) {
          input.checked = false;
          event.stopImmediatePropagation();
          event.stopPropagation();
        }
      }, true);
    });
  }

  function bindMobileFacetApply(root) {
    root.querySelectorAll('[data-samago-mobile-apply]').forEach(function (button) {
      if (button.dataset.samagoMobileApplyBound) return;
      button.dataset.samagoMobileApplyBound = '1';
      button.addEventListener('click', function () { submitMobileFacets(button); });
    });
  }

  function buildSlider(pr) {
    if (pr.dataset.samagoSlider) return;
    var inputs = pr.querySelectorAll('input.field__input');
    if (inputs.length < 2) return;
    pr.dataset.samagoSlider = '1';

    var gte = inputs[0], lte = inputs[1];
    var realMax = Math.ceil(parseMoney(lte.getAttribute('data-max')) || 0);
    var step = sliderStep(realMax);
    var max = extendedMax(realMax);

    var wrap = document.createElement('div');
    wrap.className = 'samago-price-slider';
    wrap.innerHTML =
      '<div class="samago-price-slider__out"><span class="v vmin"></span>' +
      '<span class="sep">—</span><span class="v vmax"></span></div>' +
      '<div class="samago-price-slider__rail"><div class="samago-price-slider__fill"></div>' +
      '<button type="button" class="samago-price-slider__thumb thumb-min" aria-label="Ajustar precio mínimo"></button>' +
      '<button type="button" class="samago-price-slider__thumb thumb-max" aria-label="Ajustar precio máximo"></button>' +
      '<input type="range" class="rmin" min="0" max="' + max + '" step="' + step + '" aria-label="Precio mínimo">' +
      '<input type="range" class="rmax" min="0" max="' + max + '" step="' + step + '" aria-label="Precio máximo"></div>';
    pr.insertBefore(wrap, pr.firstChild);

    var rmin = wrap.querySelector('.rmin'),
        rmax = wrap.querySelector('.rmax'),
        fill = wrap.querySelector('.samago-price-slider__fill'),
        vmin = wrap.querySelector('.vmin'),
        vmax = wrap.querySelector('.vmax'),
        thumbMin = wrap.querySelector('.thumb-min'),
        thumbMax = wrap.querySelector('.thumb-max');

    // En mobile, Dawn puede reconstruir el drawer después de aplicar facetas pero
    // devolver estos inputs sin sus values. La URL ya contiene el rango canónico
    // que filtró el catálogo, así que ésa es la fuente de verdad visual del slider.
    // El comportamiento de desktop queda sin cambios.
    var mobileFacetForm = pr.closest('form#FacetFiltersFormMobile');
    var state = mobileFacetForm ? getPriceState() : null;
    var activeMin = state && state.gteName === gte.name ? state.min : null;
    var activeMax = state && state.lteName === lte.name ? state.max : null;
    var iv = activeMin != null ? activeMin : parseMoney(gte.value);
    var xv = activeMax != null ? activeMax : parseMoney(lte.value);
    var init = normalizeRange(iv != null ? Math.round(iv) : 0, xv != null ? Math.round(xv) : max);
    rmin.value = init.min;
    rmax.value = init.max;

    function draw() {
      var r = normalizeRange(+rmin.value, +rmax.value);
      vmin.textContent = fmt(r.min);
      vmax.textContent = fmt(r.max);
      var minPosition = (r.min / max * 100) + '%';
      var maxPosition = (r.max / max * 100) + '%';
      fill.style.left = minPosition;
      fill.style.width = ((r.max - r.min) / max * 100) + '%';
      if (thumbMin) thumbMin.style.left = minPosition;
      if (thumbMax) thumbMax.style.left = maxPosition;
      // En mobile, el input nativo conserva el arrastre de Safari. Cada input
      // se recorta a su propia pelotita para evitar que dos ranges superpuestos
      // compitan por el mismo gesto.
      rmin.style.setProperty('--samago-thumb-position', minPosition);
      rmax.style.setProperty('--samago-thumb-position', maxPosition);
    }

    // El arrastre marca el slider como "sucio": tiene un rango elegido por el usuario que
    // todavía no se aplicó, y ningún resync desde la URL debe pisarlo (ver
    // syncMobilePriceSlidersFromActiveState). La marca se limpia al reconstruir el slider
    // tras el render de facetas, cuando la URL ya refleja lo aplicado.
    function markDirty() { pr.dataset.samagoSliderDirty = '1'; }
    function onRangeInput() { markDirty(); draw(); }
    rmin.addEventListener('input', onRangeInput);
    rmax.addEventListener('input', onRangeInput);
    bindMobileRailGesture();

    // Los campos numéricos nativos quedan ocultos (también por CSS) pero en el DOM.
    inputs.forEach(function (i) { var f = i.closest('.field'); if (f) f.style.display = 'none'; });
    pr.querySelectorAll('.field-currency').forEach(function (c) { c.style.display = 'none'; });

    draw();

    // Desktop usa los ranges nativos. En el drawer móvil de Safari, dos ranges
    // superpuestos y una capa vacía por encima no reciben el gesto de manera
    // consistente. Los marcadores visibles son botones reales: capturan el
    // arrastre desde el dedo, aun cuando éste sale de su círculo, y actualizan
    // los mismos values canónicos que usa Apply.
    function bindMobileRailGesture() {
      if (!mobileFacetForm) return;
      var rail = wrap.querySelector('.samago-price-slider__rail');
      if (!rail || !thumbMin || !thumbMax) return;

      var activeInput = null;
      var activePointerId = null;
      var activeTouch = false;

      function clientX(event) {
        var touch = event.touches && event.touches[0];
        if (!touch && event.changedTouches && event.changedTouches[0]) touch = event.changedTouches[0];
        return touch ? touch.clientX : event.clientX;
      }

      function nearestInput(event) {
        var rect = rail.getBoundingClientRect();
        var x = clientX(event);
        var minX = rect.left + ((Number(rmin.value) / max) * rect.width);
        var maxX = rect.left + ((Number(rmax.value) / max) * rect.width);
        return Math.abs(x - minX) <= Math.abs(x - maxX) ? rmin : rmax;
      }

      function addPointerTracking() {
        window.addEventListener('pointermove', movePointer, { passive: false, capture: true });
        window.addEventListener('pointerup', endPointer, true);
        window.addEventListener('pointercancel', endPointer, true);
      }

      function removePointerTracking() {
        window.removeEventListener('pointermove', movePointer, true);
        window.removeEventListener('pointerup', endPointer, true);
        window.removeEventListener('pointercancel', endPointer, true);
      }

      function addTouchTracking() {
        window.addEventListener('touchmove', moveTouch, { passive: false, capture: true });
        window.addEventListener('touchend', endTouch, true);
        window.addEventListener('touchcancel', endTouch, true);
      }

      function removeTouchTracking() {
        window.removeEventListener('touchmove', moveTouch, true);
        window.removeEventListener('touchend', endTouch, true);
        window.removeEventListener('touchcancel', endTouch, true);
      }

      function moveInput(event) {
        if (!activeInput) return;
        var rect = rail.getBoundingClientRect();
        if (!rect.width) return;
        var progress = Math.max(0, Math.min(1, (clientX(event) - rect.left) / rect.width));
        var next = Math.round((progress * max) / step) * step;
        if (activeInput === rmin) next = Math.min(next, Number(rmax.value));
        else next = Math.max(next, Number(rmin.value));
        activeInput.value = String(next);
        markDirty();
        draw();
      }

      function startPointer(input, event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        activeTouch = false;
        activePointerId = event.pointerId;
        activeInput = input;
        try { event.currentTarget.setPointerCapture(event.pointerId); } catch (error) {}
        addPointerTracking();
        event.preventDefault();
        event.stopPropagation();
        moveInput(event);
      }

      function movePointer(event) {
        if (!activeInput || event.pointerId !== activePointerId) return;
        event.preventDefault();
        moveInput(event);
      }

      function endPointer(event) {
        if (event.pointerId !== activePointerId) return;
        removePointerTracking();
        activePointerId = null;
        activeInput = null;
      }

      function startTouch(input, event) {
        // En navegadores que emiten Pointer Events y Touch Events, el puntero ya
        // tomó el control. En los que no, este es el camino completo de arrastre.
        if (activePointerId != null) return;
        activeTouch = true;
        activeInput = input;
        addTouchTracking();
        event.preventDefault();
        event.stopPropagation();
        moveInput(event);
      }

      function moveTouch(event) {
        if (!activeTouch || !activeInput) return;
        event.preventDefault();
        moveInput(event);
      }

      function endTouch() {
        if (!activeTouch) return;
        removeTouchTracking();
        activeTouch = false;
        activeInput = null;
      }

      function startRailPointer(event) {
        startPointer(nearestInput(event), event);
      }

      function startRailTouch(event) {
        startTouch(nearestInput(event), event);
      }

      function stopDrawerClick(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      thumbMin.addEventListener('pointerdown', startPointer.bind(null, rmin), { passive: false, capture: true });
      thumbMax.addEventListener('pointerdown', startPointer.bind(null, rmax), { passive: false, capture: true });
      thumbMin.addEventListener('touchstart', startTouch.bind(null, rmin), { passive: false, capture: true });
      thumbMax.addEventListener('touchstart', startTouch.bind(null, rmax), { passive: false, capture: true });
      rail.addEventListener('pointerdown', startRailPointer, { passive: false, capture: true });
      rail.addEventListener('touchstart', startRailTouch, { passive: false, capture: true });
      thumbMin.addEventListener('click', stopDrawerClick, true);
      thumbMax.addEventListener('click', stopDrawerClick, true);
      rail.addEventListener('click', stopDrawerClick, true);
    }
  }

  var pending = false;
  // Las mutaciones internas del slider (draw() reescribe las etiquetas $min/$max en cada
  // gesto) NO deben re-disparar enhance(): su resync repondría el slider mobile desde la
  // URL —todavía sin el rango elegido— y desharía el arrastre un frame después de soltar.
  // Ese era el bug de "slider congelado" en mobile. Solo mutaciones externas cuentan.
  function isSliderInternalMutation(record) {
    var node = record.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    return !!(node && node.closest && node.closest('.samago-price-slider'));
  }
  // Tarjetas de producto agregadas (Ver todos, fila de escritorio) o cambios dentro de una
  // tarjeta no necesitan re-correr enhance(): sus badges, precios y botones vienen del Liquid y
  // de sus propios scripts. Solo un cambio externo fuera de las tarjetas re-arma filtros y marcas.
  function isProductCardNode(node) {
    if (node.nodeType === 3) return !node.textContent.trim();
    return node.nodeType === 1 && node.classList.contains('grid__item');
  }
  function isProductCardMutation(record) {
    var node = record.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (node && node.closest && node.closest('.grid__item')) return true;
    if (record.type !== 'childList' || record.removedNodes.length || !record.addedNodes.length) return false;
    return Array.prototype.every.call(record.addedNodes, isProductCardNode);
  }
  // Nuestros propios cambios (marcas, Ver todos) no deben re-disparar enhance().
  function discardOwnMutations() {
    observer.takeRecords();
  }
  var observer = new MutationObserver(function (records) {
    if (records.every(function (record) { return isSliderInternalMutation(record) || isProductCardMutation(record); })) return;
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; enhance(); });
  });

  function observe() {
    var t = getSamagoRoot();
    if (t) observer.observe(t, { childList: true, subtree: true });
  }

  function getPriceState() {
    var params = new URLSearchParams(window.location.search);
    var gv = null, lv = null, gname = null, lname = null;
    params.forEach(function (val, key) {
      if (gname == null && /price.*gte/i.test(key)) { gv = val; gname = key; }
      if (lname == null && /price.*lte/i.test(key)) { lv = val; lname = key; }
    });
    getScopedSelectorAll('price-range input.field__input').forEach(function (input) {
      if (!input.name) return;
      if (gname == null && /price.*gte/i.test(input.name)) { gname = input.name; }
      if (lname == null && /price.*lte/i.test(input.name)) { lname = input.name; }
    });
    gname = gname || 'filter.v.price.gte';
    lname = lname || 'filter.v.price.lte';
    var minN = gv != null ? parseMoney(gv) : null;
    var maxN = lv != null ? parseMoney(lv) : null;
    if (minN != null && maxN != null && minN > maxN) { var t = minN; minN = maxN; maxN = t; }
    return {
      params: params,
      gteName: gname,
      lteName: lname,
      min: minN,
      max: maxN
    };
  }

  // Dawn no vuelve a montar el detalle del filtro que originó el refresh. Por eso,
  // luego de aplicar Precio, el slider ya existente debe volver a leer la URL
  // canónica para que sus handles y etiquetas reflejen el rango que filtró el grid.
  // Se limita al form mobile para no alterar la interfaz desktop.
  function syncMobilePriceSlidersFromActiveState(root) {
    var state = getPriceState();
    root.querySelectorAll('form#FacetFiltersFormMobile price-range').forEach(function (pr) {
      // Un slider con arrastre en curso o pendiente de Aplicar no se pisa desde la URL.
      // La marca se limpia al reconstruirlo tras el render de facetas.
      if (pr.dataset.samagoSliderDirty) return;
      var wrap = pr.querySelector('.samago-price-slider');
      var inputs = pr.querySelectorAll('input.field__input');
      if (!wrap || inputs.length < 2) return;

      var gte = inputs[0], lte = inputs[1];
      var rmin = wrap.querySelector('.rmin');
      var rmax = wrap.querySelector('.rmax');
      var fill = wrap.querySelector('.samago-price-slider__fill');
      var vmin = wrap.querySelector('.vmin');
      var vmax = wrap.querySelector('.vmax');
      if (!rmin || !rmax || !fill || !vmin || !vmax) return;

      var max = Number(rmax.max) || extendedMax(Math.round(parseMoney(lte.getAttribute('data-max')) || 0));
      var minValue = state.gteName === gte.name && state.min != null ? state.min : parseMoney(gte.value);
      var maxValue = state.lteName === lte.name && state.max != null ? state.max : parseMoney(lte.value);
      var range = normalizeRange(
        minValue != null ? Math.round(minValue) : 0,
        maxValue != null ? Math.round(maxValue) : max
      );

      rmin.value = range.min;
      rmax.value = range.max;
      vmin.textContent = fmt(range.min);
      vmax.textContent = fmt(range.max);
      fill.style.left = (range.min / max * 100) + '%';
      fill.style.width = ((range.max - range.min) / max * 100) + '%';
      var thumbMin = wrap.querySelector('.thumb-min');
      var thumbMax = wrap.querySelector('.thumb-max');
      if (thumbMin) thumbMin.style.left = (range.min / max * 100) + '%';
      if (thumbMax) thumbMax.style.left = (range.max / max * 100) + '%';
      // El área táctil nativa se recorta alrededor de cada thumb. Después de
      // renderizar filtros Dawn conserva este nodo y llega a este sincronizador
      // (sin pasar por draw), por lo que también hay que actualizar su zona de
      // hit-test. Si no, la pelotita se ve en su nueva posición pero iOS sigue
      // escuchando en la posición anterior y el slider parece estático.
      rmin.style.setProperty('--samago-thumb-position', (range.min / max * 100) + '%');
      rmax.style.setProperty('--samago-thumb-position', (range.max / max * 100) + '%');
    });
  }

  // En Safari móvil, dos inputs range superpuestos pueden conservar la posición
  // de sus thumbs aunque se actualice .value. Cuando Dawn conserva el detalle de
  // Precio tras el refresh, lo reconstruimos desde la URL activa: así labels,
  // franja y ambos thumbs nacen con el mismo rango canónico.
  var mobilePriceSliderRebuildPending = false;
  function rebuildMobilePriceSlidersFromActiveState(root) {
    if (mobilePriceSliderRebuildPending) return;
    mobilePriceSliderRebuildPending = true;
    requestAnimationFrame(function () {
      mobilePriceSliderRebuildPending = false;
      root.querySelectorAll('form#FacetFiltersFormMobile price-range').forEach(function (pr) {
        var slider = pr.querySelector('.samago-price-slider');
        if (slider) slider.remove();
        delete pr.dataset.samagoSlider;
        delete pr.dataset.samagoSliderDirty;
        buildSlider(pr);
      });
    });
  }

  // La faceta de Precio que dispara una búsqueda puede conservar su nodo durante
  // el refresh, por lo que no siempre activa nuestro MutationObserver. Enganchamos
  // el final del render nativo de Dawn y sincronizamos en el próximo frame, cuando
  // la URL y los inputs ya representan el resultado aplicado.
  function bindMobilePriceSliderRefresh() {
    if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderFilters) return;
    if (FacetFiltersForm.renderFilters.samagoPriceSliderSync) return;

    var originalRenderFilters = FacetFiltersForm.renderFilters;
    FacetFiltersForm.renderFilters = function () {
      var result = originalRenderFilters.apply(this, arguments);
      requestAnimationFrame(function () {
        var root = getSamagoRoot();
        if (root) rebuildMobilePriceSlidersFromActiveState(root);
      });
      return result;
    };
    FacetFiltersForm.renderFilters.samagoPriceSliderSync = true;
  }

  function urlWithParams(params) {
    params.delete('page');
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function navigateFilterParams(params, event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    params.delete('page');
    var qs = params.toString();
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(qs, null);
      return;
    }
    window.location.assign(urlWithParams(params));
  }

  function navigateFacetUrl(url, event) {
    var parsed = new URL(url, window.location.origin);
    if (parsed.pathname !== window.location.pathname) {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      window.location.assign(parsed.href);
      return;
    }
    navigateFilterParams(new URLSearchParams(parsed.search), event);
  }

  function applyPriceParams(params) {
    navigateFilterParams(params, null);
  }

  // Si la URL llegó con el rango invertido (gte > lte) — link compartido, editado a mano o
  // un input nativo sin normalizar — se corrige intercambiando los valores y recargando.
  // Nunca se deja aplicado un filtro inválido al catálogo (evita el "0 productos" fantasma).
  function normalizeUrlPriceParams() {
    var state = getPriceState();
    var gv = state.params.get(state.gteName), lv = state.params.get(state.lteName);
    if (gv == null || lv == null) return false;
    var a = parseMoney(gv), b = parseMoney(lv);
    if (a == null || b == null || a <= b) return false;
    state.params.set(state.gteName, String(b));
    state.params.set(state.lteName, String(a));
    window.location.replace(urlWithParams(state.params));
    return true;
  }

  function isFreeShippingDisabled(state) {
    return state.max != null && state.max < FREE_SHIPPING_THRESHOLD;
  }

  function isFreeShippingActive(state) {
    return !isFreeShippingDisabled(state) && state.min != null && state.min >= FREE_SHIPPING_THRESHOLD;
  }

  // Shopify puede aplicar marcas que omite en filter.active_values. Completar
  // solamente sus chips faltantes, también después de navegación AJAX e historial.
  function vendorChipState(search, renderedVendors) {
    var params = new URLSearchParams(search);
    return Array.from(new Set(params.getAll('filter.p.vendor'))).filter(function (vendor) {
      return vendor && renderedVendors.indexOf(vendor) === -1;
    }).map(function (vendor) {
      var remaining = new URLSearchParams(search);
      remaining.delete('filter.p.vendor');
      params.getAll('filter.p.vendor').forEach(function (value) {
        if (value !== vendor) remaining.append('filter.p.vendor', value);
      });
      remaining.delete('page');
      return { vendor: vendor, query: remaining.toString() };
    });
  }

  function syncVendorChips() {
    var selected = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
    getScopedSelectorAll('.samago-activefilters, .active-facets-mobile').forEach(function (box) {
      box.querySelectorAll('[data-samago-vendor-chip]').forEach(function (chip) { chip.remove(); });
      var rendered = [];
      box.querySelectorAll('.samago-activefilters__pill, .active-facets__button').forEach(function (link) {
        var remaining = new URL(link.href, window.location.origin).searchParams.getAll('filter.p.vendor');
        var removed = selected.filter(function (vendor) { return remaining.indexOf(vendor) === -1; });
        if (removed.length === 1) rendered.push(removed[0]);
      });
      var mobile = box.classList.contains('active-facets-mobile');
      vendorChipState(window.location.search, rendered).forEach(function (state) {
        // Crear el enlace antes de conectar facet-remove: su constructor lo necesita.
        var tmp = document.createElement('div');
        tmp.innerHTML = mobile
          ? '<facet-remove data-samago-vendor-chip><a class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary"><span data-brand-label></span><span class="svg-wrapper" aria-hidden="true">×</span></span></a></facet-remove>'
          : '<facet-remove class="samago-activefilters__item" data-samago-vendor-chip><a class="samago-activefilters__pill"><span class="samago-activefilters__k">Marca:</span><span class="samago-activefilters__v" data-brand-label></span><span class="samago-activefilters__x" aria-hidden="true">×</span></a></facet-remove>';
        var link = tmp.querySelector('a');
        link.setAttribute('href', window.location.pathname + (state.query ? '?' + state.query : ''));
        link.setAttribute('aria-label', 'Quitar filtro de marca: ' + state.vendor);
        tmp.querySelector('[data-brand-label]').textContent = (mobile ? 'Marca: ' : '') + state.vendor;
        var clear = box.querySelector('.samago-activefilters__clear, .active-facets__button-wrapper');
        box.insertBefore(tmp.firstElementChild, clear || null);
      });
      if (mobile) box.classList.toggle('samago-mobile-activefacets--empty', !box.querySelector('.active-facets__button'));
    });
  }

  // Inyecta (o quita) la pill de PRECIO en filtros activos leyendo la URL. A prueba de balas:
  // no depende de que Shopify renderice min_value. Busca el param de precio por patrón.
  function syncPriceChip() {
    var box = getActiveFiltersBox();
    if (!box) return;
    var state = getPriceState();
    var existing = box.querySelector('[data-samago-price]');
    if (existing) existing.remove();
    if (state.min == null && state.max == null) return;
    // Si falta el LTE en la URL, el máximo mostrado es el mismo techo extendido del slider —
    // nunca el data-max crudo de la colección, que puede quedar por debajo del mínimo elegido
    // y daría una pill invertida (ej. "$100.000,00 – $65.953,00").
    var pin = getScopedSelectorAll('price-range input.field__input');
    var realMax = pin[1] ? Math.round(parseMoney(pin[1].getAttribute('data-max')) || 0) : 0;
    var sliderMax = extendedMax(realMax);
    var r = normalizeRange(state.min != null ? state.min : 0, state.max != null ? state.max : sliderMax);
    var rp = new URLSearchParams(window.location.search);
    rp.delete(state.gteName);
    rp.delete(state.lteName);
    var rurl = window.location.pathname + (rp.toString() ? '?' + rp.toString() : '');
    // IMPORTANTE: crear vía innerHTML (con el <a> ya adentro). document.createElement('facet-remove')
    // corre el constructor de Dawn sobre un elemento vacío (this.querySelector('a')===null) → rompe
    // y el elemento queda display:none. Con innerHTML, el custom element se upgradea al conectarse.
    var tmp = document.createElement('div');
    tmp.innerHTML =
      '<facet-remove class="samago-activefilters__item" data-samago-price="1">' +
        '<a href="' + rurl + '" class="samago-activefilters__pill">' +
          '<span class="samago-activefilters__k">Precio:</span>' +
          '<span class="samago-activefilters__v">' + fmt(r.min) + ' – ' + fmt(r.max) + '</span>' +
          '<span class="samago-activefilters__x" aria-hidden="true">✕</span>' +
          '<span class="visually-hidden">Quitar filtro de precio</span>' +
        '</a>' +
      '</facet-remove>';
    // Siempre ANTES de "Eliminar todos": el server rinde ese botón al final de sus pills,
    // y un appendChild dejaría la pill de precio después de él (botón "en el medio").
    var clear = box.querySelector('.samago-activefilters__clear');
    box.insertBefore(tmp.firstElementChild, clear || null);
  }

  function syncFreeShippingFilter() {
    var state = getPriceState();
    var disabled = isFreeShippingDisabled(state);
    var active = isFreeShippingActive(state);
    getScopedSelectorAll('[data-samago-free-shipping-filter]').forEach(function (block) {
      var button = block.querySelector('.samago-free-shipping__toggle');
      block.classList.toggle('is-disabled', disabled);
      block.classList.toggle('is-active', active);
      if (button) {
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (!button.dataset.samagoFreeShippingBound) {
          button.dataset.samagoFreeShippingBound = '1';
          button.addEventListener('click', function () {
            var fresh = getPriceState();
            if (isFreeShippingDisabled(fresh)) return;
            var params = new URLSearchParams(window.location.search);
            if (isFreeShippingActive(fresh)) {
              params.delete(fresh.gteName);
            } else {
              params.set(fresh.gteName, String(FREE_SHIPPING_THRESHOLD));
            }
            applyPriceParams(params);
            // Dawn engancha a TODOS los <button> del drawer su "cerrar submenú"
            // (onCloseButtonClick): este toggle cierra el drawer entero vía
            // closeSubmenu → closeAnimation, camino que quita [open] pero nunca
            // limpia overflow-hidden-mobile del body (eso solo lo hace
            // closeMenuDrawer) → el scroll táctil quedaba muerto. Se limpia acá.
            if (block.closest('form#FacetFiltersFormMobile')) {
              document.body.classList.remove('overflow-hidden-mobile');
            }
          });
        }
      }
    });
  }

  function syncFreeShippingChip() {
    var box = getActiveFiltersBox();
    if (!box) return;
    var existing = box.querySelector('[data-samago-free-shipping]');
    if (existing) existing.remove();
    var state = getPriceState();
    if (!isFreeShippingActive(state)) return;
    var rp = new URLSearchParams(window.location.search);
    rp.delete(state.gteName);
    var rurl = urlWithParams(rp);
    var tmp = document.createElement('div');
    tmp.innerHTML =
      '<facet-remove class="samago-activefilters__item" data-samago-free-shipping="1">' +
        '<a href="' + rurl + '" class="samago-activefilters__pill">' +
          '<span class="samago-activefilters__k">Envío gratis:</span>' +
          '<span class="samago-activefilters__v">desde ' + fmt(FREE_SHIPPING_THRESHOLD) + '</span>' +
          '<span class="samago-activefilters__x" aria-hidden="true">✕</span>' +
          '<span class="visually-hidden">Quitar filtro de envío gratis</span>' +
        '</a>' +
      '</facet-remove>';
    var clear = box.querySelector('.samago-activefilters__clear');
    box.insertBefore(tmp.firstElementChild, clear || null);
  }

  function clearAllFiltersUrl(defaultUrl) {
    var root = getSamagoRoot();
    if (!root || !root.classList.contains('samago-search-results')) return defaultUrl;
    var params = new URLSearchParams(window.location.search);
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'samago_brand' || key === 'page') params.delete(key);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  // El botón "Eliminar todos" va SIEMPRE al final de todos los chips y solo existe con 2+
  // filtros activos. El server puede rendirlo en otra posición (o no rendirlo, porque su
  // conteo del filtro de precio no es confiable); acá se garantiza posición y existencia.
  // Su href sin query hace que Dawn (onActiveFilterClick → renderPage('')) recargue el
  // listado sin ningún parámetro: elimina precio, envío gratis y el resto de una.
  function syncClearAll() {
    observer.disconnect();
    var box = getActiveFiltersBox();
    if (!box) { observe(); return; }
    var clear = box.querySelector('.samago-activefilters__clear');
    var chips = box.querySelectorAll('.samago-activefilters__item').length;
    if (chips < 2) { if (clear) clear.remove(); observe(); return; }
    if (!clear) {
      var clearUrl = clearAllFiltersUrl(window.location.pathname);
      var tmp = document.createElement('div');
      tmp.innerHTML =
        '<facet-remove class="samago-activefilters__clear">' +
          '<a href="' + clearUrl + '" class="samago-activefilters__clearlink">Eliminar todos</a>' +
        '</facet-remove>';
      clear = tmp.firstElementChild;
    }
    box.appendChild(clear);
    observe();
  }

  function getProductGrid() {
    return getScopedSelector('#product-grid.product-grid') || getScopedSelector('#product-grid .product-grid');
  }

  function getProductGridShell() {
    return getScopedSelector('#product-grid');
  }

  function getViewAllButton() {
    return getScopedSelector('[data-samago-view-all]');
  }

  function getGridItems(grid) {
    return grid ? Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item')) : [];
  }

  function getGridColumnCount(grid) {
    if (!grid) return 1;
    if (grid.classList.contains('grid--6-col-desktop')) return 6;
    if (grid.classList.contains('grid--5-col-desktop')) return 5;
    if (grid.classList.contains('grid--4-col-desktop')) return 4;
    if (grid.classList.contains('grid--3-col-desktop')) return 3;
    if (grid.classList.contains('grid--2-col-desktop')) return 2;
    var styles = getComputedStyle(grid);
    var template = styles.gridTemplateColumns || '';
    if (template && template !== 'none') {
      var columns = template.split(' ').filter(function (part) { return part && part !== '0px'; });
      if (columns.length > 0) return columns.length;
    }
    var items = getGridItems(grid);
    if (items.length < 2) return 1;
    var firstTop = Math.round(items[0].getBoundingClientRect().top);
    var count = 0;
    items.some(function (item) {
      if (Math.round(item.getBoundingClientRect().top) !== firstTop) return true;
      count += 1;
      return false;
    });
    return Math.max(count, 1);
  }

  function getMissingCardsForLastRow(grid) {
    var columns = getGridColumnCount(grid);
    var count = getGridItems(grid).length;
    var remainder = count % columns;
    return remainder === 0 ? 0 : columns - remainder;
  }

  function parseCollectionPage(html) {
    return new window.DOMParser().parseFromString(html, 'text/html');
  }

  function getProductItemsFromDocument(doc) {
    return Array.prototype.slice.call(
      doc.querySelectorAll('#product-grid.product-grid > .grid__item, #product-grid .product-grid > .grid__item')
    );
  }

  function appendProductCardsFromPage(doc, grid, limit, settleImmediately) {
    var sourceItems = getProductItemsFromDocument(doc);
    var appended = 0;
    var currentCount = getGridItems(grid).length;
    var existingHandles = Object.create(null);
    getGridItems(grid).forEach(function (item) {
      if (item.dataset.productHandle) existingHandles[item.dataset.productHandle] = true;
    });
    sourceItems.forEach(function (item) {
      if (limit && appended >= limit) return;
      var handle = item.dataset.productHandle;
      if (handle && existingHandles[handle]) return;
      var clone = item.cloneNode(true);
      if (settleImmediately) {
        clone.classList.add('scroll-trigger--cancel');
        clone.classList.remove('scroll-trigger--offscreen');
      }
      clone.style.setProperty('--animation-order', String(currentCount + appended + 1));
      grid.appendChild(clone);
      if (handle) existingHandles[handle] = true;
      appended += 1;
    });
    return {
      appended: appended,
      total: sourceItems.length
    };
  }

  function replaceProductCardsFromPage(doc, grid) {
    grid.innerHTML = '';
    var result = appendProductCardsFromPage(doc, grid);
    discardOwnMutations();
    return result;
  }

  function getNextPageUrlFromDocument(doc) {
    var nextButton = doc.querySelector('[data-samago-view-all]');
    return nextButton && nextButton.dataset.nextUrl ? nextButton.dataset.nextUrl : '';
  }

  function fetchRenderedPage(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo cargar la siguiente página');
        return response.text();
      })
      .then(parseCollectionPage);
  }

  // Misma página pedida solo con la sección de la grilla (Section Rendering API, como facets.js):
  // trae las mismas tarjetas sin el header, footer ni el resto del documento.
  function getSectionPageUrl(url) {
    var shell = getProductGridShell();
    var sectionId = shell && shell.dataset.id;
    if (!sectionId || !url) return '';
    var next = new URL(url, window.location.origin);
    if (next.origin !== window.location.origin) return '';
    next.searchParams.set('section_id', sectionId);
    return next.pathname + next.search;
  }

  function fetchRenderedSectionPage(url) {
    var sectionUrl = getSectionPageUrl(url);
    if (!sectionUrl) return fetchRenderedPage(url);
    return fetchRenderedPage(sectionUrl).then(function (doc) {
      // Si la respuesta no trae la grilla, se usa la página completa como antes.
      return getProductItemsFromDocument(doc).length ? doc : fetchRenderedPage(url);
    }, function () {
      return fetchRenderedPage(url);
    });
  }

  function formatCardMoney(cents) {
    return fmt((Number(cents) || 0) / 100);
  }

  function setCardProductLinks(card, url, title) {
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.href = url;
      link.setAttribute('aria-label', title);
    });
  }

  function setCardGalleryImage(card, product) {
    var image = product.images && product.images[0];
    var gallery = card.querySelector('[data-samago-card-gallery]');
    if (!image || !gallery) return;
    var imageUrl = image.src + (image.src.indexOf('?') === -1 ? '?' : '&') + 'width=533';
    var images = gallery.querySelectorAll('img');
    if (!images.length) return;
    images[0].src = imageUrl;
    images[0].removeAttribute('srcset');
    images[0].alt = product.title;
    images[0].width = image.width || 533;
    images[0].height = image.height || 533;
    images[0].classList.add('is-active');
    Array.prototype.slice.call(images, 1).forEach(function (imageNode) { imageNode.remove(); });
    gallery.querySelectorAll('[data-samago-card-prev], [data-samago-card-next]').forEach(function (control) { control.remove(); });
    var dots = gallery.querySelector('.samago-card-gallery__dots');
    if (dots) dots.innerHTML = '<span class="samago-card-gallery__dot is-active" data-samago-card-dot="0"></span>';
  }

  function updateFallbackCard(card, product) {
    var variant = (product.variants || []).find(function (item) { return item.available; });
    if (!variant) return false;
    var productUrl = '/products/' + product.handle;
    var currentPrice = Math.round(Number(variant.price) * 100);
    var compareAtPrice = Math.round(Number(variant.compare_at_price || 0) * 100);
    var hasCompareAtPrice = compareAtPrice > currentPrice;
    var promoPercent = Number(window.samagoPromoPercent) || 0;
    var promoDiscount = promoPercent > 0 ? Math.round(currentPrice * promoPercent / 100) : 0;
    if (promoPercent > 0) {
      compareAtPrice = currentPrice;
      currentPrice = currentPrice - promoDiscount;
      hasCompareAtPrice = promoDiscount > 0;
    }
    var transferPrice = Math.round(currentPrice * 0.90);
    var installmentPrice = Math.round(currentPrice / 3);
    var savings = hasCompareAtPrice ? compareAtPrice - currentPrice : 0;
    var savingsPercent = hasCompareAtPrice ? Math.round(savings * 100 / compareAtPrice) : 0;
    if (promoPercent > 0 && hasCompareAtPrice) savingsPercent = promoPercent;

    card.dataset.productHandle = product.handle;
    card.querySelectorAll('[data-samago-product-handle], [data-samago-mobile-wishlist]').forEach(function (element) {
      element.dataset.productHandle = product.handle;
    });
    card.querySelectorAll('[data-samago-mobile-card]').forEach(function (element) {
      element.dataset.samagoProductUrl = productUrl;
      element.dataset.samagoProductHandle = product.handle;
      element.dataset.samagoVariantId = String(variant.id);
      element.dataset.samagoAvailable = variant.available ? 'true' : 'false';
    });
    setCardProductLinks(card, productUrl, product.title);
    card.querySelectorAll('.card__heading a').forEach(function (link) { link.textContent = product.title; });
    card.querySelectorAll('.samago-card-brand').forEach(function (brand) {
      var vendor = product.vendor || '';
      brand.textContent = vendor || '\u00a0';
      brand.classList.toggle('samago-card-brand--spacer', !vendor);
      brand.toggleAttribute('aria-hidden', !vendor);
    });
    setCardGalleryImage(card, product);

    card.querySelectorAll('.samago-card-discount-pill').forEach(function (discountPill) {
      discountPill.toggleAttribute('data-samago-promo', promoPercent > 0);
      discountPill.hidden = !hasCompareAtPrice;
      discountPill.toggleAttribute('aria-hidden', !hasCompareAtPrice);
    });
    card.querySelectorAll('.samago-card-discount-pill__value').forEach(function (discountValue) {
      discountValue.textContent = String(savingsPercent);
    });

    card.querySelectorAll('.samago-card-price__current').forEach(function (price) { price.textContent = formatCardMoney(currentPrice); });
    card.querySelectorAll('.samago-card-price__previous').forEach(function (price) {
      price.textContent = hasCompareAtPrice ? formatCardMoney(compareAtPrice) : '\u00a0';
      price.classList.toggle('samago-card-price__previous--spacer', !hasCompareAtPrice);
      price.toggleAttribute('aria-hidden', !hasCompareAtPrice);
    });
    card.querySelectorAll('.samago-card-savings').forEach(function (price) {
      price.textContent = hasCompareAtPrice ? 'Ahorrás ' + formatCardMoney(savings) : '\u00a0';
      price.classList.toggle('samago-card-savings--spacer', !hasCompareAtPrice);
      price.toggleAttribute('aria-hidden', !hasCompareAtPrice);
    });
    card.querySelectorAll('.samago-card-installments__amount').forEach(function (amount) {
      amount.textContent = formatCardMoney(installmentPrice);
    });
    card.querySelectorAll('.samago-card-transfer__price').forEach(function (price) { price.textContent = formatCardMoney(transferPrice); });
    card.querySelectorAll('input.product-variant-id').forEach(function (input) { input.value = String(variant.id); });
    card.querySelectorAll('input[name="product-id"]').forEach(function (input) { input.value = String(product.id); });
    return true;
  }

  function fetchCollectionProductData(url, pageSize) {
    var next = new URL(url, window.location.origin);
    var query = new URLSearchParams();
    query.set('limit', String(pageSize));
    query.set('page', next.searchParams.get('page') || '1');
    if (next.searchParams.get('sort_by')) query.set('sort_by', next.searchParams.get('sort_by'));
    return fetch(next.pathname.replace(/\/$/, '') + '/products.json?' + query.toString(), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo cargar el respaldo de productos');
        return response.json();
      })
      .then(function (payload) { return payload && Array.isArray(payload.products) ? payload.products : []; });
  }

  function appendFallbackProductCards(products, grid, limit) {
    var template = getGridItems(grid)[0];
    if (!template) return 0;
    var appended = 0;
    var currentCount = getGridItems(grid).length;
    var existingHandles = Object.create(null);
    getGridItems(grid).forEach(function (item) {
      if (item.dataset.productHandle) existingHandles[item.dataset.productHandle] = true;
    });
    products.forEach(function (product) {
      if (appended >= limit || !product || !product.handle || existingHandles[product.handle]) return;
      var clone = template.cloneNode(true);
      if (!updateFallbackCard(clone, product)) return;
      clone.classList.add('scroll-trigger--cancel');
      clone.classList.remove('scroll-trigger--offscreen');
      clone.style.setProperty('--animation-order', String(currentCount + appended + 1));
      grid.appendChild(clone);
      existingHandles[product.handle] = true;
      appended += 1;
    });
    return appended;
  }

  function removeViewAllButton(button) {
    var wrapper = button && button.closest('.samago-product-section-cta-wrap');
    if (wrapper) wrapper.remove();
    else if (button) button.remove();
    discardOwnMutations();
  }

  function removePaginationControls() {
    var root = getSamagoRoot();
    if (!root) return;
    root.querySelectorAll('.pagination-wrapper').forEach(function (pagination) {
      pagination.remove();
    });
    discardOwnMutations();
  }

  function setViewAllLoading(button, loading) {
    if (!button) return;
    var label = button.querySelector('[data-samago-view-all-label]') || button;
    if (!button.dataset.originalText) button.dataset.originalText = label.textContent;
    if (loading) {
      label.textContent = button.dataset.loadingText || 'Cargando...';
      button.dataset.samagoLoading = '1';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      discardOwnMutations();
      return;
    }
    label.textContent = button.dataset.originalText;
    button.dataset.samagoLoading = '0';
    button.disabled = false;
    button.removeAttribute('aria-busy');
    discardOwnMutations();
  }

  function getFirstPageUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    return url.pathname + (url.search ? url.search : '');
  }

  function loadRemainingProductPages(url) {
    if (!url) return Promise.resolve(0);
    return fetchRenderedPage(url).then(function (doc) {
      var grid = getProductGrid();
      if (!grid) return 0;
      var result = appendProductCardsFromPage(doc, grid);
      var appendedTotal = result.appended;
      var nextUrl = getNextPageUrlFromDocument(doc);
      return nextUrl ? loadRemainingProductPages(nextUrl) : appendedTotal;
    });
  }

  function loadAllProductCards(button) {
    if (!button || !button.dataset.nextUrl || button.dataset.samagoLoading === '1') return Promise.resolve(0);
    var grid = getProductGrid();
    if (!grid) return Promise.resolve(0);
    var currentPage = parseInt(button.dataset.currentPage || new URLSearchParams(window.location.search).get('page') || '1', 10) || 1;
    setViewAllLoading(button, true);
    var firstNextUrl = Promise.resolve(button.dataset.nextUrl);
    if (currentPage > 1) {
      firstNextUrl = fetchRenderedPage(getFirstPageUrl()).then(function (doc) {
        replaceProductCardsFromPage(doc, grid);
        return getNextPageUrlFromDocument(doc);
      });
    }
    return firstNextUrl
      .then(loadRemainingProductPages)
      .then(function (appended) {
        removePaginationControls();
        removeViewAllButton(button);
        if (appended > 0 || currentPage > 1) enhance();
        return appended;
      })
      .catch(function () {
        setViewAllLoading(button, false);
        return 0;
      });
  }

  function getBatchPageUrl(button, page) {
    var url = new URL(button.dataset.nextUrl, window.location.origin);
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  // Ver todos de a tandas (solo colecciones, opt-in con data-samago-view-all-batch): cada clic
  // trae las próximas N páginas (16 c/u, ~48 tarjetas) solo con la sección de la grilla, en
  // paralelo, y las agrega en orden de página sin repetir. La URL no cambia.
  function loadProductBatch(button) {
    if (!button || !button.dataset.nextUrl || button.dataset.samagoLoading === '1') return Promise.resolve(0);
    var grid = getProductGrid();
    if (!grid) return Promise.resolve(0);
    var batchSize = parseInt(button.dataset.samagoViewAllBatch, 10) || 3;
    var totalPages = parseInt(button.dataset.totalPages, 10) || 0;
    var firstClick = !button.dataset.samagoBatchStarted;
    var currentPage = parseInt(button.dataset.currentPage || '1', 10) || 1;
    // Igual que antes: desde una ?page=N, Ver todos arranca otra vez desde la página 1.
    var replaceFromFirstPage = firstClick && currentPage > 1;
    var startPage = replaceFromFirstPage ? 1 : currentPage + 1;
    var endPage = startPage + batchSize - 1;
    if (totalPages) endPage = Math.min(endPage, totalPages);
    var pages = [];
    for (var page = startPage; page <= endPage; page++) pages.push(page);
    if (!pages.length) { removeViewAllButton(button); return Promise.resolve(0); }
    setViewAllLoading(button, true);
    var requests = pages.map(function (page) {
      return fetchRenderedSectionPage(getBatchPageUrl(button, page)).then(function (doc) {
        return { page: page, doc: doc };
      }, function () { return { page: page, doc: null }; });
    });
    return Promise.all(requests).then(function (results) {
      var appended = 0;
      var lastPage = null;
      var lastDoc = null;
      for (var i = 0; i < results.length; i++) {
        // Se agrega en orden de página y se corta en la primera que falló (el próximo clic la reintenta).
        if (!results[i].doc) break;
        if (replaceFromFirstPage && results[i].page === 1) appended += replaceProductCardsFromPage(results[i].doc, grid).appended;
        else appended += appendProductCardsFromPage(results[i].doc, grid).appended;
        lastPage = results[i].page;
        lastDoc = results[i].doc;
      }
      if (lastPage === null) {
        setViewAllLoading(button, false);
        return 0;
      }
      button.dataset.samagoBatchStarted = '1';
      button.dataset.currentPage = String(lastPage);
      removePaginationControls();
      var hasMore = totalPages ? lastPage < totalPages : Boolean(getNextPageUrlFromDocument(lastDoc));
      if (!hasMore || (lastPage === endPage && !getNextPageUrlFromDocument(lastDoc))) {
        removeViewAllButton(button);
      } else {
        button.dataset.originalText = button.dataset.loadMoreText || button.dataset.originalText || '';
        setViewAllLoading(button, false);
      }
      if (appended > 0 || replaceFromFirstPage) enhance();
      return appended;
    });
  }

  function initViewAll() {
    var button = getViewAllButton();
    if (!button) return;
    if (!button.dataset.samagoViewAllBound) {
      button.dataset.samagoViewAllBound = '1';
      button.addEventListener('click', function () {
        if (button.hasAttribute('data-samago-view-all-batch')) loadProductBatch(button);
        else loadAllProductCards(button);
      });
    }
  }

  function fillDesktopLastRow() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var grid = getProductGrid();
    var button = getViewAllButton();
    if (!grid || !button || !button.dataset.nextUrl || grid.dataset.samagoDesktopRowFill || button.dataset.samagoBatchStarted) return;
    var missing = getMissingCardsForLastRow(grid);
    if (!missing) return;

    grid.dataset.samagoDesktopRowFill = 'loading';
    fetchRenderedSectionPage(button.dataset.nextUrl)
      .then(function (doc) {
        return appendProductCardsFromPage(doc, grid, missing, true);
      })
      .then(function () {
        grid.dataset.samagoDesktopRowFill = 'done';
      })
      .catch(function () {
        // El respaldo de products.json ignora las facetas activas: con filtros aplicados
        // completaría la fila con productos ajenos al resultado (y precios de fallback).
        // Mejor fila incompleta que resultados mezclados.
        var hasActiveFilters = Array.from(new URLSearchParams(window.location.search).keys()).some(function (key) {
          return key.indexOf('filter.') === 0;
        });
        if (hasActiveFilters) {
          grid.dataset.samagoDesktopRowFill = 'done';
          return;
        }
        return fetchCollectionProductData(button.dataset.nextUrl, getGridItems(grid).length)
          .then(function (products) {
            return appendFallbackProductCards(products, grid, missing);
          })
          .then(function () {
            grid.dataset.samagoDesktopRowFill = 'done';
          })
          .catch(function () {
            delete grid.dataset.samagoDesktopRowFill;
          });
      });
  }

  function initNativeBrandFilter(root) {
    if (!root) return;
    root.querySelectorAll('[data-samago-brand-facet]').forEach(function (facet) {
      facet.remove();
    });
    root.querySelectorAll('[data-samago-native-vendor-hidden]').forEach(function (facet) {
      facet.hidden = false;
      delete facet.dataset.samagoNativeVendorHidden;
    });
    bindNativeBrandSelectionLimit(root);
  }

  function normalizeBrandSearchText(value) {
    var text = String(value || '').trim().toLocaleLowerCase('es');
    try { return text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (error) { return text; }
  }

  function missingBrandValues(allValues, nativeValues) {
    var known = new Set(nativeValues);
    return allValues.filter(function (value) {
      var key = String(value || '');
      if (!key.trim() || known.has(key)) return false;
      known.add(key);
      return true;
    });
  }

  function brandPreviewState(entries, query, expanded) {
    var rows = [];
    var matches = 0;
    var clipped = 0;
    var visible = entries.map(function (entry) {
      var key = entry.key != null ? entry.key : normalizeBrandSearchText(entry.name);
      var matchesQuery = !query || key.indexOf(query) !== -1;
      if (matchesQuery) matches += 1;
      if (rows.indexOf(entry.top) === -1) rows.push(entry.top);
      var outsidePreview = rows.indexOf(entry.top) >= BRAND_PREVIEW_ROWS;
      if (outsidePreview && !entry.checked) clipped += 1;
      return Boolean(entry.checked || (matchesQuery && (query || expanded || !outsidePreview)));
    });
    return { visible: visible, showMore: !query && clipped > 0, empty: Boolean(query) && matches === 0 };
  }

  // Normalized brand names are reused across sorts, searches and re-renders.
  var brandKeyCache = new Map();
  var brandPriorityRank = null;
  function brandKey(value) {
    var raw = String(value || '');
    var key = brandKeyCache.get(raw);
    if (key === undefined) { key = normalizeBrandSearchText(raw); brandKeyCache.set(raw, key); }
    return key;
  }

  function getBrandPriorityRank() {
    if (brandPriorityRank) return brandPriorityRank;
    brandPriorityRank = new Map();
    BRAND_PRIORITY.forEach(function (name, index) {
      var key = brandKey(name);
      if (!brandPriorityRank.has(key)) brandPriorityRank.set(key, index);
    });
    return brandPriorityRank;
  }

  function getCollectionVendors(source) {
    if (!source) return null;
    if (source.samagoVendorsText === source.textContent) return source.samagoVendors;
    var vendors = null;
    try { vendors = JSON.parse(source.textContent); } catch (error) { vendors = null; }
    source.samagoVendorsText = source.textContent;
    source.samagoVendors = vendors;
    return vendors;
  }

  function supplementCollectionBrands(root, list, additionalVendors, onlyValues, startHidden) {
    var source = root.querySelector('[data-samago-collection-vendors]');
    var template = list.querySelector('li');
    if (!template || (!source && !additionalVendors)) return;
    var vendors = additionalVendors || getCollectionVendors(source);
    if (!Array.isArray(vendors)) return;
    if (onlyValues) vendors = vendors.filter(function (vendor) { return onlyValues.indexOf(vendor) !== -1; });
    if (!vendors.length) return;
    var nativeValues = Array.from(list.querySelectorAll('input[name="filter.p.vendor"]')).map(function (input) { return input.value; });
    var selected = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
    var fragment = document.createDocumentFragment();
    missingBrandValues(vendors, nativeValues).forEach(function (vendor, index) {
      var item = template.cloneNode(true);
      var input = item.querySelector('input[name="filter.p.vendor"]');
      var label = item.querySelector('label');
      var id = 'SamagoVendorExtra-' + index + '-' + Math.random().toString(36).slice(2);
      input.id = id;
      input.value = vendor;
      input.checked = selected.indexOf(vendor) !== -1;
      input.disabled = false;
      input.removeAttribute('data-samago-brand-limit-bound');
      label.setAttribute('for', id);
      label.classList.remove('disabled');
      label.classList.toggle('active', input.checked);
      item.classList.remove('hidden', 'show-more-item');
      item.hidden = false;
      item.style.display = '';
      var visibleText = item.querySelector('.facet-checkbox__text');
      visibleText.textContent = '';
      var name = document.createElement('span');
      name.className = 'facet-checkbox__text-label';
      name.textContent = vendor;
      visibleText.appendChild(name);
      var accessibleText = label.querySelector('.visually-hidden');
      if (accessibleText) accessibleText.textContent = vendor;
      // Built hidden when renderBrands decides visibility right after, so the first cut never lays out every brand.
      if (startHidden) { item.hidden = true; item.style.display = 'none'; }
      fragment.appendChild(item);
    });
    list.appendChild(fragment);
    // Both the initial collection supplement and async search supplement share the native policy.
    bindNativeBrandSelectionLimit(list);
  }

  function bindBrandDetailsEvents(details, renderBrands, refreshBrands, cleanupResize) {
    if (details.samagoBrandPresentationCleanup) details.samagoBrandPresentationCleanup();
    function onToggle() { if (details.open) renderBrands(); }
    function onOptions() { refreshBrands(); renderBrands(); }
    details.addEventListener('toggle', onToggle);
    details.addEventListener('samago:brand-options-ready', onOptions);
    details.samagoBrandPresentationCleanup = function () {
      details.removeEventListener('toggle', onToggle);
      details.removeEventListener('samago:brand-options-ready', onOptions);
      if (cleanupResize) cleanupResize();
    };
  }

  function brandViewportBucket() {
    var width = window.innerWidth || 0;
    return width >= 990 ? 2 : width >= 750 ? 1 : 0;
  }

  function initNativeBrandSearch(root) {
    var processedDetails = new Set();
    root.querySelectorAll('input[name="filter.p.vendor"]').forEach(function (vendorInput) {
      var details = vendorInput.closest('.facets__disclosure-vertical, .mobile-facets__details');
      if (!details || processedDetails.has(details)) return;
      processedDetails.add(details);
      var list = details.querySelector('.facets__list--vertical, .mobile-facets__list');
      if (!list) return;
      // Each rendered list is set up once; later enhance() calls skip it entirely.
      if (list.samagoBrandListReady) return;
      list.samagoBrandListReady = true;

      var search = details.querySelector('[data-samago-native-brand-search]');
      if (search && search.dataset.samagoBrandSearchBound) {
        // Same as before: a list re-rendered under an already bound search only gets the missing brands.
        supplementCollectionBrands(root, list);
        return;
      }
      // Brands already selected in the URL must exist as inputs now, so the form keeps them.
      var selectedVendors = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
      if (selectedVendors.length) supplementCollectionBrands(root, list, null, selectedVendors);

      if (!search) {
        var listId = list.id || 'SamagoBrandValues-' + Math.random().toString(36).slice(2);
        list.id = listId;
        var searchId = 'SamagoBrandSearch-' + Math.random().toString(36).slice(2);
        var searchWrap = document.createElement('div');
        searchWrap.className = 'samago-native-brand-search';
        searchWrap.innerHTML = '<label class="visually-hidden" for="' + searchId + '">Buscar marca</label><input id="' + searchId + '" class="samago-native-brand-search__input" type="search" placeholder="Buscar marca" autocomplete="off" aria-controls="' + listId + '" data-samago-native-brand-search><p class="samago-native-brand-search__empty" aria-live="polite" hidden>No encontramos marcas con ese nombre.</p>';
        list.parentNode.insertBefore(searchWrap, list);
        search = searchWrap.querySelector('[data-samago-native-brand-search]');
      }

      search.dataset.samagoBrandSearchBound = '1';
      var expanded = false;
      var built = false;
      var items = [];
      var entries = [];
      var more = null;
      var lastBucket = -1;
      var lastWidth = 0;
      var collator = typeof Intl !== 'undefined' && Intl.Collator ? new Intl.Collator('es') : null;
      function compareText(a, b) { return collator ? collator.compare(a, b) : a.localeCompare(b, 'es'); }
      function orderItems() {
        var rank = getBrandPriorityRank();
        var fallbackRank = BRAND_PRIORITY.length;
        var keyed = Array.from(list.querySelectorAll(':scope > li')).map(function (item, index) {
          var input = item.querySelector('input[name="filter.p.vendor"]');
          var key = brandKey(input.value);
          var itemRank = rank.get(key);
          return { item: item, input: input, label: item.querySelector('label'), key: key, value: input.value, checked: input.checked, rank: itemRank === undefined ? fallbackRank : itemRank, index: index };
        });
        keyed.sort(function (a, b) {
          if (a.checked !== b.checked) return a.checked ? -1 : 1;
          return a.rank - b.rank || compareText(a.value, b.value) || a.index - b.index;
        });
        entries = keyed;
        items = keyed.map(function (entry) { return entry.item; });
        var fragment = document.createDocumentFragment();
        items.forEach(function (item) { fragment.appendChild(item); });
        list.appendChild(fragment);
        discardOwnMutations();
      }
      function build() {
        if (built) return;
        built = true;
        // The full brand list is only built the first time Marca is opened.
        supplementCollectionBrands(root, list, null, null, true);
        orderItems();
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'samago-native-brand-more';
        more.setAttribute('aria-controls', list.id);
        list.insertAdjacentElement('afterend', more);
        var nativeMore = details.querySelector('show-more-button');
        if (nativeMore) nativeMore.hidden = true;
        more.addEventListener('click', function () { expanded = !expanded; renderBrands(); });
        list.addEventListener('change', renderBrands);
      }
      function refreshBrands() {
        if (!built) { build(); return; }
        orderItems();
      }
      function showItem(item) {
        if (item.classList.contains('hidden')) item.classList.remove('hidden');
        if (item.hidden) item.hidden = false;
        if (item.style.display) item.style.display = '';
      }

      function renderBrands() {
        build();
        var query = normalizeBrandSearchText(search.value);
        var emptyMessage = search.closest('.samago-native-brand-search').querySelector('.samago-native-brand-search__empty');
        // Writes first: checkbox state and active labels.
        entries.forEach(function (entry) {
          entry.checked = entry.input.checked;
          if (entry.label && entry.label.classList.contains('active') !== entry.checked) entry.label.classList.toggle('active', entry.checked);
          entry.top = 0;
        });
        if (!query) {
          // Measure only as many pills as needed to find the 4th row; rows below are cut anyway.
          // Shown pills are measured together, after all writes, so hiding never shifts a measured pill.
          var measured = 0;
          var limit = expanded ? entries.length : Math.min(entries.length, 40);
          for (;;) {
            for (var i = measured; i < limit; i++) showItem(entries[i].item);
            var rows = measured ? entries.slice(0, measured).reduce(function (acc, entry) { if (acc.indexOf(entry.top) === -1) acc.push(entry.top); return acc; }, []) : [];
            for (var j = measured; j < limit; j++) {
              entries[j].top = entries[j].item.offsetTop;
              if (rows.indexOf(entries[j].top) === -1) rows.push(entries[j].top);
            }
            measured = limit;
            if (rows.length > BRAND_PREVIEW_ROWS || measured >= entries.length) break;
            limit = Math.min(entries.length, measured * 2);
          }
          for (var k = measured; k < entries.length; k++) entries[k].top = Infinity;
        }
        lastWidth = list.clientWidth;
        lastBucket = brandViewportBucket();
        var state = brandPreviewState(entries, query, expanded);
        entries.forEach(function (entry, index) {
          var show = state.visible[index];
          if (show) showItem(entry.item);
          else {
            if (!entry.item.hidden) entry.item.hidden = true;
            if (entry.item.style.display !== 'none') entry.item.style.display = 'none';
          }
        });
        more.hidden = !state.showMore;
        more.textContent = expanded ? 'Ver menos' : 'Ver todas';
        more.setAttribute('aria-expanded', String(expanded));
        emptyMessage.hidden = !state.empty;
        discardOwnMutations();
      }
      search.addEventListener('input', function (event) {
        renderBrands();
        event.stopImmediatePropagation();
        event.stopPropagation();
      });
      var resize = null;
      bindBrandDetailsEvents(details, renderBrands, refreshBrands, function () { if (resize) resize.disconnect(); });
      if (details.open) renderBrands();
      if (typeof ResizeObserver !== 'undefined') {
        resize = new ResizeObserver(function () {
          if (!list.isConnected) { resize.disconnect(); return; }
          if (!details.open || !built) return;
          // Re-cut the 3 rows only when the layout breakpoint changed, or the last cut was measured hidden.
          if (brandViewportBucket() === lastBucket && lastWidth > 0) return;
          if (list.clientWidth === 0) return;
          renderBrands();
        });
        resize.observe(list);
      }
    });
  }

  window.SamagoBrandFilter = {
    addVendors: function (details, vendors) {
      var list = details && details.querySelector('.facets__list--vertical, .mobile-facets__list');
      if (!list) return;
      supplementCollectionBrands(details, list, vendors);
      discardOwnMutations();
      details.dispatchEvent(new CustomEvent('samago:brand-options-ready'));
    }
  };

  function enhance() {
    var root = getSamagoRoot();
    if (!root) return;
    if (normalizeUrlPriceParams()) return;
    observer.disconnect();
    bindMobilePriceSliderRefresh();
    // (Ya NO forzamos abiertos los filtros: arrancan comprimidos; el usuario los despliega.)
    root.querySelectorAll('price-range').forEach(buildSlider);
    syncMobilePriceSlidersFromActiveState(root);
    bindMobileFacetInputGuard(root);
    bindMobileFacetApply(root);
    syncVendorChips();
    syncPriceChip();
    syncFreeShippingFilter();
    syncFreeShippingChip();
    initNativeBrandFilter(root);
    initNativeBrandSearch(root);
    syncClearAll();
    initViewAll();
    fillDesktopLastRow();
    observe();
  }

  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();
